import { z } from 'zod';

const ipv4 =
  /^((25[0-5]|2[0-4]\d|[01]?\d?\d)\.){3}(25[0-5]|2[0-4]\d|[01]?\d?\d)$/;

const hostname = /^[A-Za-z0-9][A-Za-z0-9.-]{0,253}$/;

export const apiKeyFormSchema = z.object({
  secretKey: z
    .string()
    .trim()
    .min(8, 'Secret key must be at least 8 characters')
    .max(128, 'Secret key must be at most 128 characters'),
  ip: z
    .string()
    .trim()
    .min(1, 'IP / host is required')
    .refine((v) => ipv4.test(v) || hostname.test(v), {
      message: 'Enter a valid IPv4 address or hostname',
    }),
  apikey: z.string().min(1, 'Generate the API key before saving'),
});

export type ApiKeyFormInput = z.infer<typeof apiKeyFormSchema>;

/**
 * Mirror the legacy "deterministic key from secret" algorithm exactly so
 * existing API consumers can reproduce the same key from the same secret
 * if they need to.
 */
export function deriveApiKey(secretKey: string, length = 64): string {
  if (!secretKey) return '';
  let seed = 0;
  for (const ch of secretKey) seed += ch.charCodeAt(0);
  const charset =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@$%&*' +
    secretKey;
  let out = '';
  for (let i = 0; i < length; i++) {
    seed = (seed * 9301 + 49297) % 233280;
    const idx = Math.floor((seed / 233280) * charset.length);
    out += charset.charAt(idx);
  }
  return out;
}
